import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpService } from 'services/http.service';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent {


  constructor(@Inject(MAT_DIALOG_DATA) public data, private snackbar: MatSnackBar,
    public dialogRef: MatDialogRef<DeleteDialogComponent>, private http: HttpService) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
  delete() {
    this.http.delete(this.data.type, this.data.id).subscribe(
      (res: any) => { this.http.showMsg(res.data.message, res.responseMessage); this.dialogRef.close(); },
      err => { this.http.errorMessage(err); });
  }

}
